import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcb0d19a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = {
  method: "POST",
  action: "/",
  class: "my-1"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3\" data-v-fcb0d19a><div class=\"login-card\" data-v-fcb0d19a><div class=\"login-body\" data-v-fcb0d19a><div class=\"row\" data-v-fcb0d19a><div class=\"col-md-12 col-12\" data-v-fcb0d19a><p style=\"font-size:1.9rem;font-weight:700;letter-spacing:0.1rem;line-height:0.5;\" data-v-fcb0d19a> Verification </p><p style=\"color:grey;font-size:1rem;font-weight:300;letter-spacing:0rem;\" data-v-fcb0d19a> A 6 - Digit PIN has been sent to your email address, enter it below to continue. </p></div></div><div class=\"form-group text-center mt-2 mx-auto verification-code\" data-v-fcb0d19a><div class=\"verification-code--inputs text-center\" data-v-fcb0d19a><input style=\"border-radius:5px !important;border:1px solid #808080a1 !important;height:35px;width:35px;margin:3px;\" class=\"p-0\" type=\"text\" maxlength=\"1\" data-v-fcb0d19a><input style=\"border-radius:5px !important;border:1px solid #808080a1 !important;height:35px;width:35px;margin:3px;\" class=\"p-0\" type=\"text\" maxlength=\"1\" data-v-fcb0d19a><input style=\"border-radius:5px !important;border:1px solid #808080a1 !important;height:35px;width:35px;margin:3px;\" class=\"p-0\" type=\"text\" maxlength=\"1\" data-v-fcb0d19a><input style=\"border-radius:5px !important;border:1px solid #808080a1 !important;height:35px;width:35px;margin:3px;\" class=\"p-0\" type=\"text\" maxlength=\"1\" data-v-fcb0d19a><input style=\"border-radius:5px !important;border:1px solid #808080a1 !important;height:35px;width:35px;margin:3px;\" class=\"p-0\" type=\"text\" maxlength=\"1\" data-v-fcb0d19a><input style=\"border-radius:5px !important;border:1px solid #808080a1 !important;height:35px;width:35px;margin:3px;\" class=\"p-0\" type=\"text\" maxlength=\"1\" data-v-fcb0d19a></div><input type=\"hidden\" id=\"verificationCode\" name=\"verificationCode\" value=\"\" data-v-fcb0d19a><span id=\"errorCodeMsg\" style=\"display:none;\" data-v-fcb0d19a></span></div></div></div></div>", 1)
const _hoisted_6 = { class: "col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3" }
const _hoisted_7 = { class: "row justify-content-center mx-md-0 mx-1 mb-5" }
const _hoisted_8 = { class: "col-md-12 col-12 px-1" }
const _hoisted_9 = { class: "text-muted text-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  id: "subBtn",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                  class: "btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                }, " CONTINUE "),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    class: "success",
                    to: "/sign-in",
                    style: {"font-size":"0.9rem","color":"#333"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Back to login ? ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}